import type { $Fetch } from 'ofetch';
import type {
  DocumentoAprovacaoGateway, ListFilaValidacaoParams,
  AprovarDocumentoCommand, NegarDocumentoCommand,
} from '@/application/port/out/DocumentoAprovacaoGateway';
import type { Documento } from '@/domain/model/Documento';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/**
 * HTTP gateway pro fluxo de aprovação de Documento (acadadmin/secretaria).
 *
 * @since G.5.2
 */
export class HttpDocumentoAprovacaoGateway implements DocumentoAprovacaoGateway {
  constructor(private readonly client: $Fetch) {}

  async listFila(params: ListFilaValidacaoParams): Promise<Page<Documento>> {
    const query: Record<string, string | number> = {
      page: params.page ?? 0,
      size: params.size ?? 50,
    };
    if (params.status) query.status = params.status;
    const res = await this.client<ApiResponse<Page<Documento>>>(
      '/api/v1/admin/documentos/fila', { method: 'GET', params: query });
    assertApiSuccess(res);
    return res.data;
  }

  async aprovar(id: string, cmd: AprovarDocumentoCommand): Promise<Documento> {
    const res = await this.client<ApiResponse<Documento>>(
      `/api/v1/admin/documentos/${encodeURIComponent(id)}/aprovar`,
      { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async negar(id: string, cmd: NegarDocumentoCommand): Promise<Documento> {
    const res = await this.client<ApiResponse<Documento>>(
      `/api/v1/admin/documentos/${encodeURIComponent(id)}/negar`,
      { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async pedirComplementacao(id: string, cmd: NegarDocumentoCommand): Promise<Documento> {
    const res = await this.client<ApiResponse<Documento>>(
      `/api/v1/admin/documentos/${encodeURIComponent(id)}/complementacao`,
      { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }
}
